import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom'; // Añadir useNavigate
import Select from 'react-select';
import Swal from 'sweetalert2'; // Importar SweetAlert

import { obtenerListaEmpresas } from '../../../../store/Empresa/thunkEmpresa';

import { crearAgenda } from '../../../../store/agenda/thunkAgenda';
import { traerTodoslosClientesSegunlaempresa } from '../../../../store/clientes/thunkClientes';


export const CrearAgenda = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate(); // Para redirigir después de crear
    const [searchParams] = useSearchParams(); // Hook para obtener parámetros de la URL

    // Obtener la fecha de la URL si existe
    const fechaDesdeURL = searchParams.get('data');

    // Opciones predefinidas para el tipo de agenda con sus colores asignados
    const tiposAgenda = [
        { value: 'Inspección', label: 'Inspección', color: '#2980b9' }, // Añadido nuevo
        { value: 'Llamada', label: 'Llamada', color: '#e74c3c' },
        { value: 'Cita', label: 'Cita', color: '#9b59b6' },
        { value: 'Tarea', label: 'Tarea', color: '#eb984e' }
    ];

    // Generamos opciones de horas cada 30 minutos
    const generarOpcionesHora = () => {
        const opciones = [];
        for (let hora = 7; hora <= 22; hora++) { // De 7:00 AM a 10:00 PM
            // Formato para hora en punto (7:00, 8:00)
            opciones.push({
                value: `${hora.toString().padStart(2, '0')}:00`,
                label: `${hora % 12 === 0 ? 12 : hora % 12}:00 ${hora < 12 ? 'AM' : 'PM'}`
            });
            // Formato para media hora (7:30, 8:30)
            opciones.push({
                value: `${hora.toString().padStart(2, '0')}:30`,
                label: `${hora % 12 === 0 ? 12 : hora % 12}:30 ${hora < 12 ? 'AM' : 'PM'}`
            });
        }
        return opciones;
    };

    const opcionesHora = generarOpcionesHora();

    // Estado para el formulario - inicializamos fechas con el valor de la URL si existe
    const [formData, setFormData] = useState({
        nombre_agenda: '',
        tipo_agenda: '',
        color_agenda: '', // Nuevo campo para el color
        fecha_inicio_agenda: fechaDesdeURL || '',
        hora_inicio_agenda: '',
        fecha_fin_agenda: fechaDesdeURL || '',
        hora_fin_agenda: '',
        estado_agenda: 'pendiente',
        ubicacion_agenda: '', // Nuevo campo para ubicación
        descripcion_agenda: '',
        id_cliente: '',
        nombre_cliente: '',
        correo_cliente: '',
        telefono_cliente: '',
        id_empresa: ''
    });

    // Estados para las opciones de selección
    const [empresasOpciones, setEmpresasOpciones] = useState([]);
    const [clientesOpciones, setClientesOpciones] = useState([]);
    const [clientesData, setClientesData] = useState([]);

    // Cargar empresas al iniciar
    useEffect(() => {
        const cargarEmpresas = async () => {
            try {
                const empresasData = await dispatch(obtenerListaEmpresas());
                const opcionesEmpresas = empresasData.map(({ id_empresa, nombre_empresa }) => ({
                    value: id_empresa,
                    label: nombre_empresa,
                }));
                setEmpresasOpciones(opcionesEmpresas);
            } catch (error) {
                console.error("Error al cargar empresas:", error);
            }
        };

        cargarEmpresas();
    }, [dispatch]);

    // Función para manejar el cambio de empresa y cargar sus clientes
    const handleEmpresaChange = async (selectedOption) => {
        const selected = selectedOption ? selectedOption.value : '';

        setFormData({
            ...formData,
            id_empresa: selected,
            // Limpiar datos del cliente cuando cambia la empresa
            id_cliente: '',
            nombre_cliente: '',
            correo_cliente: '',
            telefono_cliente: ''
        });

        if (selected) {
            try {
                const leadData = await dispatch(traerTodoslosClientesSegunlaempresa(selected));
                setClientesData(leadData);

                const options = leadData.map(({ id_cliente, nombre_cliente }) => ({
                    value: id_cliente,
                    label: nombre_cliente,
                }));

                setClientesOpciones(options);
            } catch (error) {
                console.error("Error al cargar clientes:", error);
                setClientesOpciones([]);
            }
        } else {
            setClientesOpciones([]);
            setClientesData([]);
        }
    };

    // Función para manejar el cambio de cliente
    const handleClienteChange = (selectedOption) => {
        const selectedClientId = selectedOption ? selectedOption.value : '';

        if (selectedClientId) {
            const clienteCompleto = clientesData.find(cliente =>
                cliente.id_cliente === selectedClientId
            );

            if (clienteCompleto) {
                setFormData({
                    ...formData,
                    id_cliente: clienteCompleto.id_cliente,
                    nombre_cliente: clienteCompleto.nombre_cliente,
                    correo_cliente: clienteCompleto.correo_cliente || '',
                    telefono_cliente: clienteCompleto.telefono_cliente || ''
                });
            }
        } else {
            setFormData({
                ...formData,
                id_cliente: '',
                nombre_cliente: '',
                correo_cliente: '',
                telefono_cliente: ''
            });
        }
    };

    // Función para manejar el cambio del tipo de agenda
    const handleTipoAgendaChange = (selectedOption) => {
        if (selectedOption) {
            // Asignar tipo y color correspondiente
            const tipoSeleccionado = tiposAgenda.find(tipo => tipo.value === selectedOption.value);
            setFormData({
                ...formData,
                tipo_agenda: tipoSeleccionado.value,
                color_agenda: tipoSeleccionado.color
            });
        } else {
            setFormData({
                ...formData,
                tipo_agenda: '',
                color_agenda: ''
            });
        }
    };

    // Función para manejar el cambio de fecha de inicio
    const handleFechaInicioChange = (e) => {
        const fechaInicio = e.target.value;
        setFormData({
            ...formData,
            fecha_inicio_agenda: fechaInicio,
            fecha_fin_agenda: fechaInicio // Copiamos la fecha de inicio a la fecha fin
        });
    };

    // Función para manejar el cambio de hora de inicio
    const handleHoraInicioChange = (selectedOption) => {
        const horaInicio = selectedOption ? selectedOption.value : '';

        let horaFin = '';
        if (horaInicio) {
            // Calculamos una hora después
            const [horas, minutos] = horaInicio.split(':').map(Number);
            const horaFinal = horas + 1;
            horaFin = `${horaFinal.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}`;
        }

        setFormData({
            ...formData,
            hora_inicio_agenda: horaInicio,
            hora_fin_agenda: horaFin
        });
    };

    // Función para manejar el cambio de hora de fin
    const handleHoraFinChange = (selectedOption) => {
        setFormData({
            ...formData,
            hora_fin_agenda: selectedOption ? selectedOption.value : ''
        });
    };

    // Manejar cambios en los campos del formulario
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // Manejar envío del formulario
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Mostrar diálogo de confirmación antes de crear la agenda
            const confirmResult = await Swal.fire({
                icon: 'question',
                title: '¿Estás seguro?',
                text: '¿Deseas crear este evento en la agenda?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, crear',
                cancelButtonText: 'Cancelar'
            });

            // Solo continuar si el usuario confirma
            if (confirmResult.isConfirmed) {

                // Muestra un mensaje con un preloader indicando que el proceso está en curso.
                Swal.fire({
                    title: "Creando agenda ...",
                    text: "Por favor, espere mientras termina el proceso.",
                    icon: "info",
                    allowOutsideClick: false, // Evita que el usuario cierre el modal haciendo clic afuera.
                    allowEscapeKey: false, // Evita que el usuario cierre el modal usando la tecla Escape.
                    didOpen: () => {
                        Swal.showLoading(); // Muestra una animación de carga.
                    },
                });
                // Llamar a la función para crear la agenda
                await dispatch(crearAgenda(formData));

                // Mostrar alerta de éxito
                Swal.fire({
                    icon: 'success',
                    title: '¡Éxito!',
                    text: 'Se ha creado una nueva agenda correctamente',
                    confirmButtonColor: '#3085d6'
                }).then((result) => {
                    if (result.isConfirmed) {
                        // Opcional: redirigir a la lista de agendas
                        navigate('/agenda/personal');
                    }
                });

                // Limpiar formulario o realizar otras acciones necesarias
                setFormData({
                    nombre_agenda: '',
                    tipo_agenda: '',
                    color_agenda: '',
                    fecha_inicio_agenda: '',
                    hora_inicio_agenda: '',
                    fecha_fin_agenda: '',
                    hora_fin_agenda: '',
                    estado_agenda: 'pendiente',
                    ubicacion_agenda: '', // Añadir a la limpieza del formulario
                    descripcion_agenda: '',
                    id_cliente: '',
                    nombre_cliente: '',
                    correo_cliente: '',
                    telefono_cliente: '',
                    id_empresa: ''
                });
            }
            // Si el usuario cancela, no se hace nada

        } catch (error) {
            console.error("Error al crear la agenda:", error);

            // Mostrar alerta de error
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo crear la agenda. Por favor, inténtelo de nuevo.'
            });
        }
    };

    // Estilos personalizados para los selectores
    const customStyles = {
        control: (provided) => ({
            ...provided,
            borderRadius: '0.375rem',
            borderColor: '#ced4da',
            minHeight: '38px',
            boxShadow: 'none',
            '&:hover': {
                borderColor: '#86b7fe'
            }
        }),
        option: (provided, state) => {
            // Si es un tipo de agenda con color, mostramos un indicador de color
            const isAgendaType = tiposAgenda.some(tipo => tipo.value === state.data.value);
            const tipoAgenda = tiposAgenda.find(tipo => tipo.value === state.data.value);

            return {
                ...provided,
                backgroundColor: state.isSelected ? '#007bff' :
                    state.isFocused ? '#f8f9fa' : 'white',
                ...(isAgendaType && {
                    borderLeft: `4px solid ${tipoAgenda.color}`
                })
            };
        }
    };

    return (


        <>
            <h2 className="card-title mb-4">Crear Nueva Agenda</h2>
            <form onSubmit={handleSubmit}>
                <div className="row">
                    {/* Columna izquierda */}
                    <div className="col-md-6">
                        {/* Nombre de agenda */}
                        <div className="mb-3">
                            <label className="form-label">Nombre de la Agenda*</label>
                            <input
                                type="text"
                                className="form-control"
                                name="nombre_agenda"
                                value={formData.nombre_agenda}
                                onChange={handleInputChange}
                                required
                            />
                        </div>

                        {/* Fecha inicio */}
                        <div className="mb-3">
                            <label className="form-label">Fecha Inicio*</label>
                            <input
                                type="date"
                                className="form-control"
                                name="fecha_inicio_agenda"
                                value={formData.fecha_inicio_agenda}
                                onChange={handleFechaInicioChange}
                                required
                            />
                        </div>

                        {/* Fecha fin */}
                        <div className="mb-3">
                            <label className="form-label">Fecha Fin*</label>
                            <input
                                type="date"
                                className="form-control"
                                name="fecha_fin_agenda"
                                value={formData.fecha_fin_agenda}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                    </div>

                    {/* Columna derecha */}
                    <div className="col-md-6">
                        {/* Tipo de agenda */}
                        <div className="mb-3">
                            <label className="form-label">Tipo de Agenda*</label>
                            <Select
                                options={tiposAgenda}
                                onChange={handleTipoAgendaChange}
                                placeholder="Seleccione tipo de agenda"
                                isClearable
                                styles={customStyles}
                                className="basic-select"
                                classNamePrefix="select"
                                value={tiposAgenda.find(option => option.value === formData.tipo_agenda) || null}
                                required
                            />
                            {formData.tipo_agenda && (
                                <div className="mt-2 d-flex align-items-center">
                                    <div
                                        style={{
                                            width: '20px',
                                            height: '20px',
                                            backgroundColor: formData.color_agenda,
                                            borderRadius: '4px',
                                            marginRight: '8px',
                                            border: '1px solid #dee2e6'
                                        }}
                                    />
                                    <small className="text-muted">Color asignado para este tipo de agenda</small>
                                </div>
                            )}
                        </div>

                        {/* Hora inicio */}
                        <div className="mb-3">
                            <label className="form-label">Hora Inicio*</label>
                            <Select
                                options={opcionesHora}
                                onChange={handleHoraInicioChange}
                                placeholder="Seleccione hora"
                                isClearable
                                styles={customStyles}
                                className="basic-select"
                                classNamePrefix="select"
                                value={opcionesHora.find(option => option.value === formData.hora_inicio_agenda) || null}
                                required
                            />
                        </div>

                        {/* Hora fin */}
                        <div className="mb-3">
                            <label className="form-label">Hora Fin*</label>
                            <Select
                                options={opcionesHora}
                                onChange={handleHoraFinChange}
                                placeholder="Seleccione hora"
                                isClearable
                                styles={customStyles}
                                className="basic-select"
                                classNamePrefix="select"
                                value={opcionesHora.find(option => option.value === formData.hora_fin_agenda) || null}
                                required
                            />
                        </div>
                    </div>
                </div>

                {/* Ubicación (ocupa todo el ancho) */}
                <div className="row mb-3">
                    <div className="col-12">
                        <label className="form-label">Ubicación</label>
                        <input
                            type="text"
                            className="form-control"
                            name="ubicacion_agenda"
                            value={formData.ubicacion_agenda}
                            onChange={handleInputChange}
                            placeholder="Ingrese la ubicación del evento"
                        />
                    </div>
                </div>

                {/* Descripción (ocupa todo el ancho) */}
                <div className="row mb-3">
                    <div className="col-12">
                        <label className="form-label">Descripción</label>
                        <textarea
                            className="form-control"
                            name="descripcion_agenda"
                            value={formData.descripcion_agenda}
                            onChange={handleInputChange}
                            rows="3"
                        />
                    </div>
                </div>

                {/* Empresa y Cliente */}
                <div className="row mb-3">
                    <div className="col-md-6 mb-3">
                        <label className="form-label">Empresa</label>
                        <Select
                            options={empresasOpciones}
                            onChange={handleEmpresaChange}
                            placeholder="Buscar y seleccionar empresa"
                            isClearable
                            styles={customStyles}
                            className="basic-select"
                            classNamePrefix="select"
                            value={empresasOpciones.find(option => option.value === formData.id_empresa) || null}
                        />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label">Cliente</label>
                        <Select
                            options={clientesOpciones}
                            onChange={handleClienteChange}
                            placeholder="Buscar y seleccionar cliente"
                            isClearable
                            isDisabled={!formData.id_empresa}
                            styles={customStyles}
                            className="basic-select"
                            classNamePrefix="select"
                            value={clientesOpciones.find(option => option.value === formData.id_cliente) || null}
                        />
                    </div>
                </div>

                {/* Botones de acción */}
                <div className="d-flex mt-4">
                    <button type="submit" className="btn btn-primary">
                        Guardar Agenda
                    </button>
                    <button type="button" className="btn btn-secondary ms-2">
                        Cancelar
                    </button>
                </div>
            </form>
        </>


    );
};
